
import apiClient from '../api/client';

export interface Store {
    business_id: number;
    business_name: string;
    category_name: string;
    category_icon: string | null;
    address: string;
    city: string;
    state: string;
    rating: string | number;
    total_reviews: number;
    is_open: boolean;
    banner_image: string | null;
    logo: string | null;
    country: string;
    distance_km?: string;
    distance_miles?: string;
}

export interface StoreFilters {
    latitude?: number;
    longitude?: number;
    category_id?: number;
    open_now?: boolean;
    qr_payment_only?: boolean;
    min_rating?: number;
    sort_by?: 'nearest' | 'distance' | 'highest_rated' | 'most_popular' | 'top_deals';
    order?: 'asc' | 'desc';
    limit?: number;
    page?: number;
    country?: string;
}

export interface Pagination {
    current_page: number;
    total_pages: number;
    total_items: number;
    per_page: number;
}

export interface StoresResponse {
    stores: Store[];
    pagination: Pagination;
    filters_applied: any;
}

export interface Category {
    category_id: number;
    category_name: string;
    category_icon: string | null;
    description?: string;
    is_active: boolean;
}

export interface CategoriesResponse {
    categories: Category[];
    count: number;
}

export interface StoreDetails {
    business_id: number;
    business_name: string;
    owner_name?: string;
    description?: string;
    category: {
        category_id: number;
        category_name: string;
        category_icon: string | null;
    };
    address: {
        address: string;
        city: string;
        state: string;
        pincode: string;
        country: string;
        latitude: string | number;
        longitude: string | number;
    };
    contact: {
        email: string;
        phone: string;
        website?: string;
    };
    rating: {
        average: number;
        total_reviews: number;
    };
    status: {
        is_open: boolean;
        is_24_7: boolean;
        business_timings: any;
    };
    has_qr_payment: boolean;
    banner_image: string | null;
    logo: string | null;
    photos: Array<{
        photo_id: number;
        photo_url: string;
        is_primary: boolean;
    }>;
    products: Array<{
        product_id: number;
        product_name: string;
        price: number | string;
        description: string;
        image: string | null;
        is_available: boolean;
    }>;
    recent_reviews: Array<{
        review_id: number;
        user_name: string;
        rating: number;
        comment: string;
        created_at: string;
    }>;
}

export const storeService = {
    getStores: async (filters: StoreFilters = {}) => {
        try {
            const response = await apiClient.get('/api/stores/filter', { params: filters });
            return response.data.data as StoresResponse;
        } catch (error) {
            throw error;
        }
    },

    getCategories: async () => {
        try {
            const response = await apiClient.get('/api/categories');
            return response.data.data as CategoriesResponse;
        } catch (error) {
            throw error;
        }
    },

    getStoreDetails: async (id: number | string) => {
        try {
            const response = await apiClient.get(`/api/stores/${id}`);
            return response.data.data as StoreDetails;
        } catch (error) {
            throw error;
        }
    }
};
